<ng-container *ngrxLet="triggeredAlerts$ as vm">
	@for (alert of vm.alerts; track alert.id) {
		<div @enterLeaveFastWithPadding>Alert clinician if '{{ alert.actionPropertyLabel }}' {{ alert.alertCondition | actionAlertConditionOperator }} {{ alert.valueToCompareAgainst }}</div>
	}
</ng-container>